import { map, Observable } from 'rxjs';

import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FileApiClient } from '@ideapa/app-api-client';
import { FileDto } from '@ideapa/common-dto';

@Pipe({
  standalone: false,
  name: 'getSecureImgSrc',
})
export class GetSecureImageSourcePipe implements PipeTransform {
  constructor(
    private fileApiClient: FileApiClient,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {}

  transform(attachment: FileDto): Observable<SafeUrl> {
    return (
      this.fileApiClient
        // we get the imagePath, observing the response and getting it as a 'blob'
        .download(attachment)
        .pipe(
          // we map our blob into an ObjectURL
          map((response) => {
            const blob = new Blob([response], {
              type: attachment.mimeType,
            });
            return window.URL.createObjectURL(blob);
          }),
          // we bypass Angular's security mechanisms
          map((unsafeBlobUrl: string) =>
            this.domSanitizer.bypassSecurityTrustUrl(unsafeBlobUrl)
          )
        )
    );
  }
}
